import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { apiKey } from "../config/config";
import { useNavigate, useParams } from "react-router-dom";
import Table from "../components/Table";
import { convertDateFormat } from "../services/helper";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReactToPrint } from "react-to-print";
import PartialPayment from "../components/PartialPayment";

function CustomerContracts({ lang }) {
  const { id } = useParams();
  

  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;
  const branchId = JSON.parse(
    JSON.parse(sessionStorage.getItem("aman-admin"))?.admin
  )?.branch_id;

  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const columns = [
    {
      header: lang["Contract No"] || "Contract No",
      accessorKey: "id",
      cell: (row) => row.getValue() * 9999,
    },
    {
      header: lang["Customer_Name"] || "Customer Name",
      accessorKey: "customer_name",
    },
    {
      header: lang["Mobile_Number"] || "Mobile Number",
      accessorKey: "customer_mobile",
    },
    {
      header: lang.Amount || "Amount",
      accessorKey: "final_installment",
    },
    {
      header: lang["Date Contract"] || "Date Contract",
      accessorKey: "date_contract",
      cell: (row) => convertDateFormat(row.getValue()),
    },
    {
      header: lang.Note || "Note",
      accessorKey: "customer_note",
      cell: (row) => (row.row.original.status !== 2 ? row.getValue() : ""),
    },
    {
      header: lang.Status || "Status",
      accessorKey: "status",
      cell: (row) => {
        const status = row.getValue();
        return parseInt(status) === 1 ? (
          <span className="badge rounded-pill bg-success">
            {lang.active || "Active"}
          </span>
        ) : parseInt(status) === 2 ? (
          <span className="badge rounded-pill bg-primary">
            {lang.completed || "Completed"}
          </span>
        ) : parseInt(status) === 3 ? (
          <span className="badge rounded-pill bg-danger">
            {lang.defaulted || "Defaulted"}
          </span>
        ) : (
          <span className="badge rounded-pill bg-warning">
            {lang.no_contract || "No Contract"}
          </span>
        );
      },
    },
    {
      header: lang.Actions || "Actions",
      cell: (row) => (
        <div className="dropdown top-0 start-0">
          <button
            className="btn btn-primary dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {lang.Actions || "Actions"}
          </button>
          <ul className="dropdown-menu">
            <li>
              <button
                className="dropdown-item mt-0"
                onClick={() =>
                  navigate(`../customer/contract-information/${row.row.original.id}`)
                }
              >
                {lang.View || "View"}
              </button>
            </li>
            {(parseInt(row.row.original.status) === 1 || parseInt(row.row.original.status) === 3) && (
              <li>
                <button
                  className="dropdown-item mt-0"
                  type="button"
                  onClick={() => {
                    setContractData(row.row.original);
                    const modalBtn = document.createElement("button");
                    modalBtn.setAttribute("data-bs-toggle", "modal");
                    modalBtn.setAttribute("data-bs-target", "#Comodity");
                    modalBtn.style.display = "none";
                    document.body.appendChild(modalBtn);
                    modalBtn.click();
                    document.body.removeChild(modalBtn);
                  }}
                >
                  {lang.add_payment || "Add Payment"}
                </button>
              </li>
            )}
          </ul>
        </div>
      ),
    },
  ];

  const fetchContracts = useCallback(() => {
    axios
      .get(`${apiKey}/get-contracts-customer`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          branch_id: branchId,
          customer_id: id,
        },
      })
      .then((res) => {
        setData(res.data.result);
      })
      .catch((err) => {
        console.log(err?.response?.data?.message || err);
      });
  }, [branchId, id, token]);

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const [contractData, setContractData] = useState({
    id: "",
    total_value: "",
    total_paid: "",
    legal_fees: "",
    final_installment: "",
  });
  const [paymentMethod, setPaymentMethod] = useState();
  const [payment, setPayment] = useState();
  const [note, setNote] = useState();
  const [discount, setDiscount] = useState();
  const [receiptData, setReceiptData] = useState();
  const [loading, setLoading] = useState(false);
  const [toInvestor, setToInvestor] = useState("no");

  // const isLighMode =
  //   JSON.parse(
  //     JSON.parse(sessionStorage.getItem("aman-admin") || "")?.admin || ""
  //   )?.light_mode === "yes";

  const handlePayment = () => {
    setLoading(true);
    axios
      .put(
        apiKey + "/get-contract-to-update/" + contractData.id,
        {
          payment: payment,
          discount,
          paymentMethod,
          to_investor: toInvestor,
          note,
          user_id: contractData.customer_id,
          branch_id: branchId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => {
        document.getElementById("closePaymentModalButton")?.click();
        if (res.data.contract && parseInt(res.data.contract[0].status) === 2) {
          navigate(
            `/dashboard/contracts/valid-contract/complete-contract/${res.data.contract[0].id}`
          );
          window.location.reload();
        } else {
          fetchContractInfo(contractData.id, paymentMethod, true, payment, toInvestor);
        }
        fetchContracts();
        toast.success(res.data.Message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        console.error(err);
        toast.error("Error Occured", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }).finally(() => setLoading(false));
  };

  const fetchContractInfo = (id, paymentMethod, openModal = false, paidAmount = null, toInvestorVal = null) => {
    axios
      .get(`${apiKey}/get-complete-contract/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setReceiptData({
          ...res.data.result[0],
          paymentMethod,
          ...(paidAmount !== null && paidAmount !== undefined ? { amount: paidAmount } : {}),
          ...(toInvestorVal !== null && toInvestorVal !== undefined ? { to_investor: toInvestorVal } : {}),
        });
        if (openModal) {
          document.getElementById("openReceiptModalButton")?.click();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    const totalValue = Number(contractData?.total_value || 0);
    const totalPaid = Number(contractData?.total_paid || 0);
    const downPayment = Number(contractData?.down_payment || 0);
    const discountVal = Number(discount || 0);
    const noInst = Number(contractData?.no_of_installments || 1);

    const netRemaining = Math.max(0, totalValue - totalPaid - discountVal);

    if (netRemaining <= 0) {
      setPayment(0);
      return;
    }

    const totalToDistribute = Math.max(0, totalValue - downPayment);
    let baseInstallment = 0;
    let remainder = 0;

    if (noInst > 0 && totalToDistribute > 0) {
      baseInstallment = Math.floor(totalToDistribute / noInst);
      remainder = totalToDistribute - (baseInstallment * noInst);
    } else if (contractData?.final_installment) {
      baseInstallment = Math.floor(Number(contractData.final_installment));
      remainder = totalToDistribute - (baseInstallment * noInst);
    }

    if (baseInstallment <= 0) {
      baseInstallment = Math.floor(contractData?.final_installment || netRemaining);
    }

    const normalInstallment = baseInstallment > 0 ? baseInstallment : Math.floor(netRemaining);
    const lastInstallment = normalInstallment + Math.max(0, remainder);

    if (netRemaining <= lastInstallment || (netRemaining - normalInstallment) < 1) {
      setPayment(Math.round(netRemaining * 100) / 100);
    } else {
      setPayment(normalInstallment);
    }
  }, [contractData, discount]);

  useEffect(() => {
    setDiscount(contractData.discount || 0);
  }, [contractData]);

  useEffect(() => {
    if (branchId) {
      fetchContracts();
    }
  }, [branchId, fetchContracts]);

  return (
    <div>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>{lang.Customer_Management || "Customer Management"}</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                >
                  <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
                </svg>
              </li>
              <li className="breadcrumb-item">
                {lang.Customer_Management || "Customer Management"}
              </li>
              <li className="breadcrumb-item">
                {lang.Customer_List || "Customer List"}
              </li>
              <li className="breadcrumb-item active">
                {lang.Contracts || "Contracts"}
              </li>
            </ol>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="row pt-3">
                  <div className="rr col-9">{lang.Contracts || "Contracts"}</div>
                </div>
                <div className="card-body">
                  <div classNames="d-flex mt-3 mb-3">
                    <Table lang={lang} data={data} columns={columns} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* add payment modal */}
        <div className="modal fade" id="Comodity" tabindex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handlePayment();
                  }}
                >
                  <div className="row mb-2 mt-5 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Total_Value || "Total Value"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={contractData.total_value}
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Remaining || "Remaining"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={
                            contractData.total_value - contractData.total_paid
                          }
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.legal_fees || "Legal Fees"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={contractData.legal_fees}
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang["Additional Discount"] || "Additional Discount"}
                        </span>
                        <input
                          type="number"
                          className="form-control"
                          value={discount}
                          onChange={(e) => setDiscount(e.target.value)}
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Remaining || "Remaining"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={
                            contractData.total_value -
                            contractData.total_paid -
                            (discount || 0)
                          }
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.payment || "Payment"}
                        </span>
                        <input
                          type="number"
                          className="form-control"
                          max={
                            contractData.total_value - contractData.total_paid
                          }
                          value={payment}
                          onChange={(e) => setPayment(e.target.value)}
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.payment_method || "Payment Method"}
                        </span>
                        <select
                          onChange={(e) => setPaymentMethod(e.target.value)}
                          className="form-control"
                          name=""
                          id=""
                          required
                        >
                          <option value="" disabled selected></option>
                          <option value="Cash">{lang.cash || "Cash"}</option>
                          <option value="Bank Transfer">
                            {lang.bank_transfer || "Bank Transfer"}
                          </option>
                          <option value="Card">{lang.card || "Card"}</option>
                        </select>
                      </label>
                    </div>
                  </div>

                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8 mb-3">
                      <label className="w-100">
                        <span style={{ fontSize: "14px" }} className="d-block mb-1">
                          {lang.to_investor || "To Investor"}
                        </span>
                        <div className="d-flex align-items-center gap-4 pt-1">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="toInvestorValidCon"
                              id="toInvestorNoValidCon"
                              value="no"
                              checked={toInvestor === "no"}
                              onChange={(e) => setToInvestor(e.target.value)}
                            />
                            <label className="form-check-label" htmlFor="toInvestorNoValidCon" style={{ fontSize: "14px", cursor: "pointer" }}>
                              {lang.no || "No"}
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="toInvestorValidCon"
                              id="toInvestorYesValidCon"
                              value="yes"
                              checked={toInvestor === "yes"}
                              onChange={(e) => setToInvestor(e.target.value)}
                            />
                            <label className="form-check-label" htmlFor="toInvestorYesValidCon" style={{ fontSize: "14px", cursor: "pointer" }}>
                              {lang.yes || "Yes"}
                            </label>
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Note || "Note"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={note}
                          onChange={(e) => setNote(e.target.value)}
                        />
                      </label>
                    </div>
                  </div>
                  <div className="text-center mb-5">
                    <button
                      id="closePaymentModalButton"
                      type="button"
                      className="btn-save"
                      data-bs-dismiss="modal"
                    >
                      {lang.Cancel || "Cancel"}
                    </button>
                    <button disabled={loading} type="submit" className="btn-cancel ms-4">
                      {lang.Add_Now || "Add Now"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <button
          id="openReceiptModalButton"
          style={{ display: "none" }}
          data-bs-toggle="modal"
          data-bs-target="#myModal1"
        ></button>
        {/* Receipts */}
        <div className="modal fade in" id="myModal1" tabindex="-1">
          <div
            className="modal-content modal-dialog"
            style={{
              maxWidth: "80%",
            }}
          >
            <div className="modal-body print position-relative" ref={componentRef}>
              <button
                type="button"
                className="close"
                data-bs-toggle="modal"
                data-bs-target="#myModal1"
              >
                <i className="fa fa-2x">×</i>
              </button>
              <button
                type="button"
                onClick={handlePrint}
                className="btn btn-primary position-absolute top-0 end-0"
                style={{ margin: "1rem 1rem" }}
              >
                {lang.print_reciept || "Print Receipt"}
              </button>
              {receiptData && <PartialPayment contractData={receiptData} lang={lang} />}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default CustomerContracts;
